import React, { Component } from 'react';

import { RiCloseCircleFill } from 'react-icons/ri';

export class ShowFullItem extends Component {
   render() {
      return (
         <div className='show_full-item'>
            <div className="full_item-box">
               <button onClick={() => { this.props.onShowItem() }}><RiCloseCircleFill /></button>
               <span className='material__title'>{this.props.item.title}</span>
               <span className='material__text'>{this.props.item.about}</span>
               <img src={"./img/" + this.props.item.img} />
            </div>
         </div>
      )
   }
}

export default ShowFullItem
